<style>
  [tuiButton][data-appearance='flat'] {
    --tui-padding: 0.5rem;
  }
  hr {
    border-bottom: 1px solid var(--x-color-gray);
  }
</style>
@let isDesktop = deviceService.isDesktop$ | async;

@if ((canLogistChangeRequestStatus$ | async) === false) {
  <div class="x-card__title text-center text-(--x-color-danger) mt-10">
    <h5 class="typo-h5">
      {{ 'group_actions.status.no_access' | translate }}
    </h5>
  </div>
} @else {
  <div class="x-card x-card_size_m x-white card-shadow">
    @for (status of requestStatuses$ | async; track status.id) {
      <button
        tuiButton
        appearance="flat"
        type="button"
        class="w-full p-0"
        (click)="newStatusValue = status"
      >
        <span class="flex justify-between w-full">
          <div>
            <span
              class="inline-block w-4 h-4 rounded-full align-middle"
              [style.background-color]="status.color"
            ></span>
            <span
              class="typo-ui-m x-text-01 align-middle ml-2"
              [ngClass]="{
                'font-bold': status.id === newStatusValue?.id,
              }"
              >{{ 'request_statuses.' + status.id | translate }}</span
            >
          </div>

          <input
            tuiRadio
            type="radio"
            size="m"
            [checked]="status.id === newStatusValue?.id"
            (change)="newStatusValue = status"
          />
        </span>
      </button>
      <hr />
    }
    @if (newStatusValue && isDesktop) {
      <button
        appearance="primary"
        tuiButton
        type="button"
        class="x-card__footer-button"
        (click)="changeStatus()"
      >
        {{ 'group_actions.status.apply' | translate }}
      </button>
    }
  </div>
  @if (newStatusValue && !isDesktop) {
    <footer
      class="text-center h-(--x-footer-height) text-(--x-color-danger) w-screen sticky bottom-[15px]"
    >
      <div
        class="text-center backdrop-blur-lg bg-(--tui-background-neutral-1) p-4"
      >
        <button
          appearance="primary"
          tuiButton
          type="button"
          class="w-full"
          (click)="changeStatus()"
        >
          {{ 'group_actions.status.apply' | translate }}
        </button>
      </div>
    </footer>
  }
}
